import {
  IPrintBehaviorSpecifiable, instanceOfIPrintBehaviorSpecifiable,
  IEditBehaviorSpecifiable, instanceOfIEditBehaviorSpecifiable,
  IQuoteBehaviorSpecifiable, instanceOfIQuoteBehaviorSpecifiable,
  ITooltipBehaviorSpecifiable, instanceOfITooltipBehaviorSpecifiable,
  INaturalTextBehaviorSpecifiable, instanceOfINaturalTextBehaviorSpecifiable,
  IGroupAlertBehaviorSpecifiable, instanceOfIGroupAlertBehaviorSpecifiable,
  IEmptyAlertBehaviorSpecifiable, instanceOfIEmptyAlertBehaviorSpecifiable,
  ILengthAlertBehaviorSpecifiable, instanceOfILengthAlertBehaviorSpecifiable,
  ITextSearchBehaviorSpecifiable, instanceOfITextSearchBehaviorSpecifiable,
  IFreeInputBehaviorSpecifiable, instanceOfIFreeInputBehaviorSpecifiable,
  IItemGroupSelectBehaviorSpecifiable, instanceOfIItemGroupSelectBehaviorSpecifiable,
  IHisInformationItemDefaultSelectBehaviorSpecifiable, instanceOfIHisInformationItemDefaultSelectBehaviorSpecifiable,
  IHospitalizedHisInformationItemSelectBehaviorSpecifiable, instanceOfIHospitalizedHisInformationItemSelectBehaviorSpecifiable,
  IUserDefinedInformationSourceSpecifiable, instanceOfIUserDefinedInformationSourceSpecifiable,
  IUserDefinedItemSelectBehaviorSpecifiable, instanceOfIUserDefinedItemSelectBehaviorSpecifiable,
  ITranscribeBehaviorSpecifiable, instanceOfITranscribeBehaviorSpecifiable,
  ITranscribeDateOfTimeBehaviorSpecifiable, instanceOfITranscribeDateOfTimeBehaviorSpecifiable,
  IEmptyAlertAllowBehaviorSpecifiable, instanceOfIEmptyAlertAllowBehaviorSpecifiable,
  IGroupAlertAllowBehaviorSpecifiable, instanceOfIGroupAlertAllowBehaviorSpecifiable,
  IScriptExecuteTriggerBehaviorSpecifiable, instanceOfIScriptExecuteTriggerBehaviorSpecifiable,
  IDateStyle,
  ITimeStyle,
  IDateInputBehavior,
  ITimeInputBehavior,
  DateObjectKinds,
  IDateCalculateBehaviorSpecifiable,
  instanceOfIDateCalculateBehaviorSpecifiable,
  IQuestionnaireSpecifiable, instanceOfIQuestionnaireSpecifiable,
} from "../../../../documaker/domain/format/objects";
import { IDateTextDrawableObject, instanceOfIDateTextDrawableObject } from "./IDateTextDrawableObject";

export interface IDateObject extends
IDateTextDrawableObject,
IPrintBehaviorSpecifiable,
IEditBehaviorSpecifiable,
IQuoteBehaviorSpecifiable,
ITooltipBehaviorSpecifiable,
INaturalTextBehaviorSpecifiable,
IGroupAlertBehaviorSpecifiable,
IEmptyAlertBehaviorSpecifiable,
ILengthAlertBehaviorSpecifiable,
ITextSearchBehaviorSpecifiable,
IFreeInputBehaviorSpecifiable,
IItemGroupSelectBehaviorSpecifiable,
IHisInformationItemDefaultSelectBehaviorSpecifiable,
IHospitalizedHisInformationItemSelectBehaviorSpecifiable,
IDateCalculateBehaviorSpecifiable,
IUserDefinedInformationSourceSpecifiable,
IUserDefinedItemSelectBehaviorSpecifiable,
ITranscribeBehaviorSpecifiable,
ITranscribeDateOfTimeBehaviorSpecifiable,
IEmptyAlertAllowBehaviorSpecifiable,
IGroupAlertAllowBehaviorSpecifiable,
IScriptExecuteTriggerBehaviorSpecifiable,
IQuestionnaireSpecifiable {
  isDate: boolean;
  style: IDateStyle | ITimeStyle;
  inputBehavior: IDateInputBehavior | ITimeInputBehavior;
  objectKind: DateObjectKinds;
}

export function instanceOfIDateObject(instance: any): instance is IDateObject {
  return instance
      && (instance.isDate !== undefined)
      && (instance.style !== undefined)
      && (instance.inputBehavior !== undefined)
      && instanceOfIPrintBehaviorSpecifiable(instance)
      && instanceOfIEditBehaviorSpecifiable(instance)
      && instanceOfIQuoteBehaviorSpecifiable(instance)
      && instanceOfITooltipBehaviorSpecifiable(instance)
      && instanceOfINaturalTextBehaviorSpecifiable(instance)
      && instanceOfIGroupAlertBehaviorSpecifiable(instance)
      && instanceOfIEmptyAlertBehaviorSpecifiable(instance)
      && instanceOfILengthAlertBehaviorSpecifiable(instance)
      && instanceOfITextSearchBehaviorSpecifiable(instance)
      && instanceOfIFreeInputBehaviorSpecifiable(instance)
      && instanceOfIItemGroupSelectBehaviorSpecifiable(instance)
      && instanceOfIHisInformationItemDefaultSelectBehaviorSpecifiable(instance)
      && instanceOfIHospitalizedHisInformationItemSelectBehaviorSpecifiable(instance)
      && instanceOfIDateCalculateBehaviorSpecifiable(instance)
      && instanceOfIUserDefinedInformationSourceSpecifiable(instance)
      && instanceOfIUserDefinedItemSelectBehaviorSpecifiable(instance)
      && instanceOfITranscribeBehaviorSpecifiable(instance)
      && instanceOfITranscribeDateOfTimeBehaviorSpecifiable(instance)
      && instanceOfIEmptyAlertAllowBehaviorSpecifiable(instance)
      && instanceOfIGroupAlertAllowBehaviorSpecifiable(instance)
      && instanceOfIScriptExecuteTriggerBehaviorSpecifiable(instance)
      && instanceOfIQuestionnaireSpecifiable(instance)
      && instanceOfIDateTextDrawableObject<IDateObject>(instance);
}
